import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=61b415be&"
import script from "./DashboardCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports